import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import events from "../data/events";
import "../style/EventDetailPage.css";

const EventCarousel = ({ images }) => {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? images.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === images.length - 1 ? 0 : c + 1));

  return (
    <div className="event-carousel">
      <button className="event-carousel-btn event-carousel-prev" onClick={prev}>‹</button>
      <img src={images[current]} alt={`Slide ${current + 1}`} className="event-carousel-img" />
      <button className="event-carousel-btn event-carousel-next" onClick={next}>›</button>
      <div className="event-carousel-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`event-carousel-dot${i === current ? " active" : ""}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </div>
  );
};

const EventDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const event = events.find((e) => e.id === parseInt(id));

  if (!event) {
    return (
      <div className="event-detail-page">
        <button className="event-detail-back" onClick={() => navigate(-1)}>← Back</button>
        <h2>Event not found</h2>
      </div>
    );
  }

  return (
    <div className="event-detail-page">
      <button className="event-detail-back" onClick={() => navigate(-1)}>← Back to Events</button>
      <div className="event-detail-card">
        <span className="event-detail-date">{event.date}</span>
        <h1 className="event-detail-title">{event.name}</h1>
        {event.images && event.images.length > 2 && (
          <EventCarousel images={event.images} />
        )}
        {event.images && event.images.length > 0 && event.images.length <= 2 && (
          <div className="event-detail-images">
            {event.images.map((img, i) => (
              <img key={i} src={img} alt={`${event.name} ${i + 1}`} className="event-detail-img" />
            ))}
          </div>
        )}
        {event.description && (
          <div className="event-detail-desc">
            {event.description.split("\n\n").map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        )}
        {event.link && (
          <a className="event-detail-link" href={event.link} target="_blank" rel="noopener noreferrer">
            Learn more about this event →
          </a>
        )}
      </div>
    </div>
  );
};

export default EventDetailPage;
